import React from "react";
import AdminApp from "./components/AdminApp";
import ArticlePage from "./components/ArticlePage";
import PublicSite from "./components/PublicSite";

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/admin" || path.startsWith("/admin/")) return <div data-auto-i18n><AdminApp /></div>;
  if (path.startsWith("/artikuj/")) return <ArticlePage identifier={path.slice("/artikuj/".length)} />;
  return <PublicSite />;
}
